/**
 * @generated SignedSource<<071a1c5671e60f2d33490752563ac25e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerAllMenuFocusQuery$data = {
  readonly focusQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "headerAllMenuFocusQuery";
};
export type headerAllMenuFocusQuery$key = {
  readonly " $data"?: headerAllMenuFocusQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuFocusQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "entityLink"
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerAllMenuFocusQuery",
  "selections": [
    {
      "alias": "focusQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "all_menu_focus"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 2
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "Topic",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v0/*: any*/),
                      "type": "Section",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:2)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"all_menu_focus\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "86fd688bdf2c366e3c57db294dba5e04";

export default node;
